import React, { useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import slugify from "slugify";

//assets
import doodle from "assets/svg/doodle-eyes.svg";


//styles
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";
import colors from "styles/colors.js";

//components
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";

import Btn from "components/global/Btn.js";
import Body from "components/global/typography/text/Body.js";

import Media from "components/global/Media.js";



const Wrapper = styled.div`
background-color: ${colors.purple };
position: relative;
height: 50rem;
flex: 1 1 0;
border-radius: ${distances.radius}rem;
transition: all 0.3s ease-in-out;
overflow: hidden;
${({ $active }) => $active && css`
flex: 0 0 50%;
max-width: 50%;
transition: all 0.3s ease-in-out;
`}

@media all and (max-width: ${mediaQuery.tablet}) {
  flex: 0 0 calc(100% - 4rem);
  width: calc(100% - 4rem);
  max-width: calc(100% - 4rem) !important;
  scroll-snap-align: start;
}
`;

const ContentWrapper = styled.div`
margin: 1rem 0 0 1rem ;
color: ${colors.dark};
display: flex;
flex-direction: column;
gap: 1.6rem;
`;


const Title = styled.h2`
font-size: ${typographySizes.text.tekstSize6.size.desktop}rem;
line-height: 1.1;
font-family: "neue-haas-grotesk-text", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
color: inherit;
width: 40rem;
font-weight: 500;
margin-right: 2rem;
@media all and (max-width: ${mediaQuery.tablet}) {
  font-size: ${typographySizes.text.tekstSize6.size.mobile}rem;
  width: 100%;

}
`;

const SideTitle = styled.span`
font-size: ${typographySizes.text.tekstSize1.size.desktop}rem;
position: absolute;
bottom: 1rem;
right: 1rem;
transform-origin: bottom right;
transform: rotate(-90deg) translate(100%, 0);
z-index: 1;
font-weight: 500;
transition: all 0.3s ease-in-out;
${({ $active }) => $active && css`
transform: rotate(-90deg) translate(100%, 200%);

`}

@media all and (max-width: ${mediaQuery.tablet}) {
  display: none;
}
`;

const Description = styled.p`
font-size: ${typographySizes.text.tekstSize1.size.desktop}rem;
line-height: ${typographySizes.text.tekstSize1.lineHeight};
color: inherit;
width: 32rem;
`;

const MediaWrapper = styled.div`
  position: absolute;

transition: all 0.3s ease-in-out;



  z-index: 1;
  border-radius: calc( ${distances.radius}rem - 0.1rem);
  overflow: hidden;

  @media all and (min-width: ${mediaQuery.tablet}) {

    ${({ $active }) => !$active && css`
  width: 100%;
  height: 100%;
  bottom: 0rem;
  right: 0rem;

  &::after{
    content:  "";
    background-color: black;
    opacity: 0.5;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 0.3s ease-in-out;
  }
  `}

  ${({ $active }) => $active && css`

  height: 50%;
  width: 50%;
  bottom: 1rem;
  right: 1rem;
  &::after{
    content:  "";
    background-color: black;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 0.3s ease-in-out;
  }
  `}

  }

  @media all and (max-width: ${mediaQuery.tablet}) {
    width: 21rem;
    height: 12rem;
    bottom: 1rem;
    right: 1rem;
  }
`;

const ServiceItem = ({ service, active, onMouseEnter }) => {
  return (
    <Wrapper $active={active} onMouseEnter={onMouseEnter}>
    <ContentWrapper>
  <Title>{service.Title}</Title>
  {service.Description && (
    <Description>{service.Description}</Description>
  )}
  <Btn to={`/services#${slugify(service.Title, { lower: true, strict: true })}`} pageLink> More</Btn>
  </ContentWrapper>
  <MediaWrapper $active={active}>
    <Media media={service.Thumbnail_media} />
  </MediaWrapper>
 <SideTitle $active={active}>{service.Title}</SideTitle>
    </Wrapper>
  );
};

export default ServiceItem;
